export enum RebateType {
  SALES_REBATE = 'SALES_REBATE',
  PREMIER_POINT = 'PREMIER_POINT',
}
